import React from 'react';
import BaseClass from '../common/baseClass';

import { connect } from "react-redux";
import { changeFilter, changeDatalist, changeMutex, changeValues } from "../../redux/actions"; //setter
import { filterChassisSelector } from "../../redux/selectors"; //getter

const common = require('../common/common');
const env = require("../../config.js").default;

class FilterChassis extends BaseClass {
	componentWillMount() {
		this.updateStateWithStoreProps();
	}

	ResetVIN(e) {
		e.preventDefault();
		const $ = window.$;
		$("select#select_model option[value='" + this.state.filtersState.modello + "']").removeAttr("selected", "selected");
		$("input#EDTNTELA").val("");
		$('#ricerca_filtro_modello .select_modelli').val('').trigger('change');
		$("#erroreModello").css("display", "none");
		$("#erroreTelaio").css("display", "none");
		$("#ricerca_filtro_modello_pulse").removeClass("animate__animated animate__bounce");
		$("#ricerca_filtro_tavole_pulse").removeClass("animate__animated animate__bounce");
		if (!this.state.filtersState.cmoto || this.state.filtersState.applicazione) {
			$("#tavoleSelContainer").removeClass("select-focus");
			$("#modelSelContainer").removeClass("select-focus");
		}
		this.setState({ filtersState: { telaio: '', modello: '' } });
		this.props.changeValues({ filtersState: { tavola: "", telaio: "", modello: "", cmoto: "" }, renewMutex: { tavole: false } });
	}

	searchVIN(e) {
		e.preventDefault();
		const $ = window.$;
		if ($("#EDTNTELA").val() === '') {
			$("input#EDTNTELA").addClass("is-invalid");
			$("input#EDTNTELA").attr("placeholder", common.getTrad("Inserisci il telaio..."));
		} else {
			var telaio = $("#EDTNTELA").val().toUpperCase();
			$("input#EDTNTELA").removeClass("is-invalid");
			
			this.setState({ filtersState: { telaio: telaio } });
			var data = { ntela: telaio, zprod: this.state.filtersState.marca }
			common.apiCall(env.BACKEND + "epc/get_vin_model/", "GET", data, true)
				.then(response => {
					if (response.error !== false) {
						$("#erroreTelaio").css("display", "block");
						$('#erroreTelaio').html('<i class="fas fa-exclamation-triangle"></i> ' + common.getTrad("Nessuna corrispondenza trovata"));
						this.props.changeValues({ filtersState: { modello: '', tavola: '' } });
					} else {
						$("#erroreTelaio").css("display", "none");
						this.props.changeValues({ filtersState: { telaio: telaio, modello: response.CMOTO, cmoto: response.CMOTO, tavola: "" }, renewMutex: { tavole: true } });
					}
				});
		}
	}

	componentWillReceiveProps(nextProps) {
		this.changeVinCharCounter(nextProps);
		this.updateStateWithStoreProps(nextProps);
	}

	changeVinCharCounter(e) {
		const $ = window.$;
		var count = 17 - $("#EDTNTELA").val().length;
		$("#charCounterVIN").text(count);
		if (count > 0)
			$("#charCounterVIN").addClass("text-danger");
		else
			$("#charCounterVIN").removeClass("text-danger");

		if (e.which === 10 || e.which === 13)
			$("#btn_cercaT").click();
	}

	render(props) {
		const $ = window.$;
		var count = 17;
		if ($("#EDTNTELA").val() !== undefined && $("#EDTNTELA").val().length !== undefined)
			count = count - $("#EDTNTELA").val().length;
		return (
			<div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 row-eq-height " role="alert" id="ricerca_filtro_telaio">
				<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 content_filtro">
					<h4 id="label-EDTNTELA">{common.getTrad("Ricerca Telaio")}
						<figure className="svg" src={env.MENU_ICONS_PATH + (window.cc.usePersonalIcons ? window.cc.csoft : "900000") + "/menu-telaio.svg"} alt={common.getTrad("Ricerca Telaio")} title={common.getTrad("Ricerca Telaio")}></figure></h4>
					<hr />
					<div className="input-group">
						<input readOnly={this.state.filtersState.telaio ? true : false} name="EDTNTELA" id="EDTNTELA" aria-labelledby="label-EDTNTELA" onKeyUp={(e) => this.changeVinCharCounter(e)} className="form-control input-sm text-uppercase" type="text" defaultValue={this.state.filtersState.telaio} maxLength="17" />
						<span className="input-group-btn bottone_ricerca">
							{!this.state.filtersState.telaio && $('#erroreTelaio').css('display') !== 'block' ?
								<button id="btn_cercaT" className="btn btn-light" onClick={e => this.searchVIN(e)}>
									<span className="d-none d-md-block d-sm-block d-md-none"><span className="fas fa-search"></span> {common.getTrad("Cerca un modello")}</span>
									<span className="d-block d-sm-none"><span className="fas fa-search"></span></span>
								</button>
								:
								<button id="btn_resetta" onClick={e => this.ResetVIN(e)} className="btn btn-light"><span className="fas fa-redo"></span> {common.getTrad("Resetta")}</button>
							}
						</span>
					</div>
					<small className="text-muted">
						{common.getTrad("Caratteri rimanenti")}: <span id="charCounterVIN" className={count > 0 ? "text-danger" : ""}>{count}</span>
					</small>
					<div style={{ display: 'none' }} id="erroreTelaio" className="alert alert-warning" role="alert"></div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	const store = filterChassisSelector(state);
	return { store };
}
export default connect(mapStateToProps, { changeFilter, changeDatalist, changeMutex, changeValues })(FilterChassis);


//export default FilterChassis;
